import { ChevronDown, ChevronUp } from 'lucide-react';
import React from 'react'
interface AccordianProps {
  data: any[]
}
const Accordian = ({ data }: AccordianProps) => {
  return (
    <div>
      {(() => {
        const [openItems, setOpenItems] = React.useState<Record<number, boolean>>({ 0: true });

 
        return (
          <div className="space-y-4">
            {data.map((item, idx) => {
              const isOpen = !!openItems[idx];
              return (
                <div key={idx} className="border rounded-xl bg-white shadow-sm">
                  <button
                  type="button"
                  className="w-full flex items-center justify-between text-left px-5 py-4"
                  onClick={() => {
                    const newOpenItems = { ...openItems };
                    Object.keys(newOpenItems).forEach(key => {
                    newOpenItems[Number(key)] = false; // Close all items
                    });
                    newOpenItems[idx] = true; // Open the clicked item
                    setOpenItems(newOpenItems);
                  }}
                  aria-label={isOpen ? "Collapse" : "Expand"}
                  >
                  <span className="font-semibold text-gray-900">{item.question}</span>
                  <span className="w-8 h-8 inline-flex items-center justify-center rounded-full bg-gray-100 text-primary">
                    {isOpen ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
                  </span>
                  </button>
                  {isOpen && (
                  <div className="px-5 pb-4 text-lg text-gray-700">
                    {item.answer}
                  </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      })()}
    </div>
  )
}

export default Accordian